import { LocalService } from './../storage/local.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '../config/config';
import { ConfigService } from './../config/config.service';
import { AesService } from '../utils/aes.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient,
    private aesService: AesService,
    private localSecureService: LocalService
  ) { }

  async login(data:any) {
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/login`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error: any) {
      return { status: false, code: error.error.status, message: error.error.title };
    }
  }

  async loginCl(data:any) {
    const config = await this.configService.getConfig();
    const url = `${config.endpoint_cl}/Login/LoginConsultora`;

    try {
      return await this.httpClient.post(url, {data: this.aesService.aesEncrypt(JSON.stringify(data))}, { headers: this.headers }).toPromise();
    } catch (error: any) {
      return { status: false, code: error.error.status, message: error.error.title };
    }
  }

  isAuthenticated(): boolean {
    if (this.localSecureService.getValue('login')) {
      return true;
    } else {
      return false;
    }
  }

  logout(): void {
    localStorage.clear();
    this.localSecureService.clearToken();
    window.location.href = `${window.location.origin}/index`;
  }

  isValid(): boolean {
    if (this.localSecureService.getValue('validated')) {
      return true;
    } else {
      return false;
    }
  }

}
